var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.115 0L9 6.885L15.885 0L18 2.13L9 11.13L0 2.13L2.115 0Z","fill":"currentColor"}));
}

ArrowInline.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 18 12"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
